import twopoolSwapABI from './json/2pool-arbitrum/swap';
import triCryptoSwap from './json/tricrypto/swap';
import triCryptoSwap2 from './json/tricrypto2/swap';
import tricryptoDepositABI from './json/tricrypto/deposit-arbitrum';
import renSwapAbi from './json/ren-arbitrum/swap';
import wstETHSwapAbi from './json/wsteth-arbitrum/swap';

import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';
import MetaUSDFactoryv241 from './json/factory-v2/MetaUSDFraxusdc';
import MetaUSDBalancesFactoryv241 from './json/factory-v2/MetaUSDBalancesFraxusdc';


import eurusdSwap from './json/eursusd/swap';
import eurusdZap from './json/eursusd/zap';


const multicall_address = '0x5b5cfe992adac0c9d48e05854b2d91c73a003858';

const poolsData = {
    '2pool': {
        swap_abi: twopoolSwapABI,
        N_COINS: 2,
        coin_precisions: [1e6, 1e6],
        wrapped_precisions: [1e6, 1e6],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        token_address: '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        gauge_address: '0xbF7E49483881C76487b0989CD7d9A8239B20CA41',
        underlying_coins: [
            '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        ],
        coins: [
            '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        ],
    },
    tricrypto: {
        swap_abi: triCryptoSwap2,
        N_COINS: 3,
        pool_type: 'crypto',
        coin_precisions: [1e6, 1e8, 1e18],
        wrapped_precisions: [1e6, 1e8, 1e18],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x960ea3e3C7FB317332d990873d354E18d7645590',
        token_address: '0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2',
        gauge_address: '0x97E2768e8E73511cA874545DC5Ff8067eB19B787',
        underlying_coins: [
          '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
          '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
          '0x82af49447d8a07e3bd95bd0d56f35241523fbab1'
        ],
        coins: [
          '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
          '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
          '0x82af49447d8a07e3bd95bd0d56f35241523fbab1'
      ],
      deposit_abi: tricryptoDepositABI,
      deposit_address: '0xF97c707024ef0DD3E77a0824555a46B622bfB500',
    },
    'ren': {
        swap_abi: renSwapAbi,
        N_COINS: 2,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb',
        token_address: '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb',
        gauge_address: '0xC2b1DF84112619D190193E48148000e3990Bf627',
        underlying_coins: [
            '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
    },
    eursusd: {
        N_COINS: 2,
        coin_precisions: [1e2, 1e18],
        wrapped_precisions: [1e2, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        swap_address: '0xA827a652Ead76c6B0b3D19dba05452E06e25c27e',
        token_address: '0x3dFe1324A0ee9d86337d06aEB829dEb4528DB9CA',
        gauge_address: '0x37C7ef6B0E23C9bd9B620A6daBbFEC13CE30D824',
        pool_type: 'crypto',
        base_pool: '2pool',
        underlying_coins: [
            '0xd22a58f79e9481d1a88e00c343885a588b34b68b',
            '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        ],
        coins: [
            '0xd22a58f79e9481d1a88e00c343885a588b34b68b',
            '0x7f90122bf0700f9e7e1f688fe926940e8839f353',
        ],
        swap_abi: eurusdSwap,
        deposit_abi: eurusdZap,
        deposit_address: '0x25e2e8d104BC1A70492e2BE32dA7c1f8367F9d2c',
        is_meta: true,
        meta_N: 4,
        meta_precisions: [1e2, 1e18, 1e6, 1e6],
        meta_coin_precisions: [1e2, 1e6, 1e6],
        meta_wrapped_precisions: [1e2, 1e18],
        meta_coins: [
            '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8', //DAI
            '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', // USDC
        ],
        all_coins: [
            '0xd22a58f79e9481d1a88e00c343885a588b34b68b',
            '0x7f90122bf0700f9e7e1f688fe926940e8839f353', //base pool lp
            '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8', //DAI
            '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9', // USDC
        ],
    },
    wsteth: {
        swap_abi: wstETHSwapAbi,
        N_COINS: 2,
        coin_precisions: [1e18, 1e18],
        wrapped_precisions: [1e18, 1e18],
        tethered: [false, false],
        use_lending: [false, false],
        is_plain: [true, true],
        has_eth: true,
        swap_address: '0x6eB2dc694eB516B16Dc9FBc678C60052BbdD7d80',
        token_address: '0xDbcD16e622c95AcB2650b38eC799f76BFC557a0b',
        gauge_address: '0x098EF55011B6B8c99845128114A9D9159777d697',
        underlying_coins: [
            '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            '0x5979D7b546E38E414F7E9822514be443A4800529',
        ],
        coins: [
            '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
            '0x5979D7b546E38E414F7E9822514be443A4800529',
        ],
    },

};


const factoryPoolDataSkeleton = {
    swap_abi: twopoolSwapABI,
    N_COINS: 2, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    token_address: '0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA', // to fill and replace w/ null in skeleton
    gauge_address: '0x8866414733F22295b7563f9C5299715D2D76CAf4', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: '3pool', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};



export {
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
    MetaUSDFactoryv241,
    MetaUSDBalancesFactoryv241,
};
